import React from 'react';
import styled from 'styled-components';

const RefreshButtonWrapper = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #666666;
  color: #e6e6e6;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 200;
  transition: background-color 0.3s ease;
  padding: 8px 16px 8px 16px;

  &:hover {
    background-color: #808080;
    box-shadow: 2px 2px 10px #7d7b7b;
  }
`;

interface IRefreshButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

function RefreshButton(props: IRefreshButtonProps) {
  return (
    <RefreshButtonWrapper {...props}>
      <i className="fa fa-refresh" style={{ marginRight: '5px' }}></i>
      Refresh
    </RefreshButtonWrapper>
  );
}

export default RefreshButton;
